import { Container } from 'react-bootstrap';
import '../../css/Content.css';
import 'bootstrap/dist/css/bootstrap.min.css'

export const Page20 = () => {




  return (
    <>      
      <section>   

      <div className='container'>

        <div style={{ paddinBottom: "80px", display: 'flex', justifyContent: 'center'}}>  

           <img src="./img/module1/page20.svg" style={{width: '75%', marginTop: '20px' }} alt="" />

        </div>

        

        
      </div>

          <div style={{display: 'flex'}}>
            <p><span className="legenda" style={{backgroundColor: '#4F2BAA'}}><strong>R</strong></span> Responsável designado a realizar a atividade</p>
            <p><span className="legenda" style={{backgroundColor: '#AD2A31'}}><strong>A</strong></span> Accountable toma a decisão e dono da atividade</p>
            <p><span className="legenda" style={{backgroundColor: '#2BAA58'}}><strong>C</strong></span> Consultado deve ser consultado antes da tomada de decisão</p>
            <p><span className="legenda" style={{backgroundColor: '#AAA32B', padding: '6px 15px'}}><strong>I</strong></span> Informado deve ser informado da decisão tomada</p>
          </div>

      </section>
      
      <style>{`

        .legenda{
          border-radius: 60%;
          padding: 6px 13px;
          color: #fff;
          font-weight: 500
        }

        p{
          font-size: 14px;
          color: #ffffff;
          text-align: center
        }


      `}</style>

    </>
  );
};

export default Page20;